import React, { useEffect, useState } from 'react';
import Button from '../../../../components/Button';
import { Box, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import { makeStyles } from 'tss-react/mui';
import { Edit } from '../../../questionBank';

const useStyles = makeStyles()((theme) => ({

}));

export const CreateQuestion = ({ handleClose, questionId, setQuestionId, setModalType, sectionId, chapterId, lessonPlanId, onQuestionUpdated }) => {

    const theme = useTheme();
    const { classes } = useStyles();
    const { courseId } = useParams();
    const [isSave, setIsSave] = useState(false);

    useEffect(() => {
        if (isSave) {
            setModalType('manage')
        }
    }, [isSave])

    const handleQuestionSaved = (savedQuestion) => {
        if (onQuestionUpdated) {
            onQuestionUpdated(savedQuestion);
        }
        setIsSave(true);
    };

    return (
        <Grid container spacing={2} >
            <Grid item xs={12}>
                <Edit
                    courseId={courseId}
                    sectionId={sectionId}
                    chapterId={chapterId}
                    planId={lessonPlanId}
                    manageQuestion={true}
                    questionId={questionId}
                    setQuestionId={setQuestionId}
                    setIsSave={setIsSave}
                    onQuestionSaved={handleQuestionSaved}
                />
            </Grid>
            <Grid item xs={12} textAlign={'right'}>
                <Button size='large' variant="contained" onClick={handleClose} color="primary" placeholder={'Back'} />
            </Grid>
        </Grid >

    )
}
